import { FreeRounds } from '../defaultObjects';
import { Utils } from '@/utils/Utils';
import { IFreeRounds } from '@/store/defaultObjects';
import { ActionContext } from 'vuex';

type State = {
  freeRounds: IFreeRounds;
};

export default {
  state: {
    freeRounds: FreeRounds
  },
  getters: {
    isFreeRounds(state: State) {
      return Boolean(state.freeRounds.bet);
    },

    getAmountLeftSpinsFreeRounds(state: State, getters: any) {
      if (!getters.isFreeRounds) return 0;

      return state.freeRounds.roundsLeft;
    },
    getCurrentLeftSpinsFreeRounds(state: State, getters: any) {
      if (!getters.isFreeRounds) return 0;

      return state.freeRounds.rounds - state.freeRounds.roundsLeft;
    },
    getAmountSpinsFreeRounds(state: State, getters: any) {
      if (!getters.isFreeRounds) return 0;

      return state.freeRounds.rounds;
    },
    getFreeRoundsCurrency(state: State, getters: any) {
      if (!getters.isFreeRounds) return '';

      return state.freeRounds.currency;
    },
    getFreeRoundsWins(state: State, getters: any) {
      if (!getters.isFreeRounds) return '';

      return state.freeRounds.wins;
    },
    getFreeRounds(state: State) {
      return state.freeRounds;
    }
  },
  mutations: {
    setFreeRounds(state: State, data: IFreeRounds) {
      state.freeRounds = JSON.parse(JSON.stringify(data));

      const { wins } = state.freeRounds;

      state.freeRounds.wins = Utils.centsToMoneyStr(
        Number(wins),
        state.freeRounds.currencyDecimals,
        state.freeRounds.currency
      );
    }
  },
  actions: {
    SET_FREE_ROUNDS_DATA({ commit }: ActionContext<any, any>, data: IFreeRounds) {
      commit('setFreeRounds', data);
    },
    CLEAR_FREE_ROUNDS({ commit }: ActionContext<any, any>) {
      commit('setFreeRounds', FreeRounds);
    }
  }
};
